import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface Topic {
  id: string;
  title: string;
  icon: string;
  content: string;
  highlighted?: boolean;
}

interface TopicDetailViewProps {
  topic: Topic;
  onBack: () => void;
}

const TopicDetailView: React.FC<TopicDetailViewProps> = ({ topic, onBack }) => {
  return (
    <div className="flex flex-col h-full p-4">
      <div className="flex items-center mb-4">
        <Button 
          variant="ghost" 
          size="sm" 
          className="p-0 mr-2" 
          onClick={onBack}
        >
          <ArrowLeft className="h-4 w-4 mr-1" />
          <span>Back</span>
        </Button>
      </div>
      
      <div className="flex items-center mb-2">
        <span className="text-2xl mr-2">{topic.icon}</span>
        <h2 className="text-lg font-semibold">{topic.title}</h2>
      </div>
      
      <div className="prose prose-sm max-w-none">
        <p>{topic.content}</p>
      </div>
      
      <div className="mt-6">
        <h3 className="text-sm font-medium mb-2">Was this helpful?</h3>
        <div className="flex space-x-2">
          <Button variant="outline" size="sm">Yes</Button>
          <Button variant="outline" size="sm">No</Button>
        </div>
      </div>

      <div className="mt-auto pt-4">
        <Button 
          className="w-full bg-gradient-to-r from-gebeya-pink to-gebeya-orange text-white hover:opacity-90 transition-opacity"
          onClick={onBack}
        >
          Contact Support
        </Button>
      </div>
    </div>
  );
};

export default TopicDetailView; 